import { REQUEST_QUOTATIONS } from "../types/RequestQuotationAction";

const INITIAL_STATE = {
  requestQuotationList: null,
  freightRateList: null,
  chaList: null,
  manufacturerList: null,
  searchRequestQuotationsList: null,
  QuotationMessages: [],
};

const RequestQuotation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQUEST_QUOTATIONS.REQUEST_QUOTATIONS_LIST_SUCCESS:
      return {
        ...state,
        requestQuotationList: action.payload,
      };
    case REQUEST_QUOTATIONS.GET_FREIGHT_RATE_RFQS_SUCCESS:
      return {
        ...state,
        freightRateList: action.payload,
      };
    case REQUEST_QUOTATIONS.GET_CHA_RFQS_SUCCESS:
      return {
        ...state,
        chaList: action.payload,
      };
    case REQUEST_QUOTATIONS.GET_MANUFACTURER_RFQS_SUCCESS:
      return {
        ...state,
        manufacturerList: action.payload,
      };
    case REQUEST_QUOTATIONS.SEARCH_PRODUCTS_QUOTATIONS_FROM_LIST_SUCCESS:
      return {
        ...state,
        searchRequestQuotationsList: action.payload,
      };
    case REQUEST_QUOTATIONS.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        QuotationMessages: action.payload,
      };
    default:
      return state;
  }
};

export default RequestQuotation;
